import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from './material/material.module';
import { PipesModule } from './pipes/pipes.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FieldModule } from './components/field/field.module';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    MaterialModule,
    PipesModule,
    ReactiveFormsModule,
    TranslateModule,
    FieldModule
  ],
  exports: [
    MaterialModule,
    PipesModule,
    TranslateModule,
    FieldModule
  ]
})
export class SharedModule { }
